module.exports = __webpack_public_path__ + "static/media/exlyIcon.80281887.svg";